export default "__VITE_ASSET__CtBvEXWJ__"